import React from "react";
import PropTypes from "prop-types";
import Typography from "@mui/material/Typography";

import NoDraggableDialog from "../../UI/InfoBoard/Standalone/NoDraggableDialog";
import { infoText } from "../../MyDataPortal/DataGrid/Dialogs/styles";

export const NEED_LOGIN = "NEED_LOGIN";
export const NEED_AUTH = "NEED_AUTH";
export const NO_DATA_NEED_LOGIN = "NO_DATA_NEED_LOGIN";
export const NO_DATA_NEED_AUTH = "NO_DATA_NEED_AUTH";

const RestoreHaveUnreturnedFilesDlg = ({ reason, cancelBtnFn }) => {
  // console.log("[RestoreHaveUnreturnedFilesDlg]", dupIds);

  const getTitle = () => {
    switch (reason) {
      case NEED_LOGIN:
      case NO_DATA_NEED_LOGIN:
        return "Login required";
      case NEED_AUTH:
      case NO_DATA_NEED_AUTH:
        return "Authorization required";
      default:
        return "Request has issue";
    }
  };

  const getContent = () => {
    switch (reason) {
      case NEED_LOGIN:
        return (
          <>
            <Typography paragraph>
              Some of the requested files are not being shown.
            </Typography>
            <Typography paragraph>
              Please log in to gain access to files you are authorized to see.
            </Typography>
          </>
        );
      case NEED_AUTH:
        return (
          <>
            <Typography sx={infoText} paragraph>
              Some of the requested files are not being shown because you are
              not authorized to see them.
            </Typography>
            <Typography sx={infoText} paragraph>
              Please contact whoever provided the link and ask them to grant you
              access to the dataset of which the files are a part.
            </Typography>
          </>
        );
      case NO_DATA_NEED_LOGIN:
        return (
          <>
            <Typography paragraph>
              None of the requested files are being shown.
            </Typography>
            <Typography paragraph>
              Please log in to gain access to files you are authorized to see.
            </Typography>
          </>
        );
      case NO_DATA_NEED_AUTH:
        return (
          <>
            <Typography sx={infoText} paragraph>
              None of the requested files are being shown because you are not
              authorized to see them.
            </Typography>
            <Typography sx={infoText} paragraph>
              Please contact whoever provided the link and ask them to grant you
              access to the dataset of which the files are a part.
            </Typography>
          </>
        );
      default:
        return <Typography> Has unknown issue </Typography>;
    }
  };

  return (
    <NoDraggableDialog
      title={getTitle()}
      width={800}
      acceptBtnFn={cancelBtnFn}
      acceptBtnText="Close"
      cancelBtnFn={cancelBtnFn}
    >
      {getContent()}
    </NoDraggableDialog>
  );
};

export default RestoreHaveUnreturnedFilesDlg;

RestoreHaveUnreturnedFilesDlg.propTypes = {
  cancelBtnFn: PropTypes.func.isRequired,
  reason: PropTypes.string.isRequired,
};
